import startFreeTrialForm from 'global/free-trial-form-multiple.src';
import Flickity from 'flickity';

[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    startFreeTrialForm.init(form);
});

var flkty = new Flickity( '.carousel', {
    initialIndex: 1,
    arrowShape: 'M76.3,79L46.5,49.3 M46.5,49.3l29.7-29.7'
});

